import React from "react";
import { Card } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { isMobile } from "react-device-detect";
import { IconLocation } from "../../../assets/icons";
function SkeletonCardComplex() {
  return (
    <Card className="p-2 rounded-3 text-center  h-100">
      <Skeleton width="174px" height="138px"></Skeleton>
      <Card.Body className="px-0 pb-0 small-svg">
        <Skeleton height="13px"></Skeleton>
        <div className="fs-075">
          <IconLocation fillColor="red" />
          <Skeleton height="13px" width="50%" className="ms-1"></Skeleton>
        </div>
      </Card.Body>
    </Card>
  );
}
export default SkeletonCardComplex;
